import axios from "axios";

export default {
	async fetchContent(context, route) {
		const contentUrl = `content/${route}`;
		const contentError = {
			error: "Error getting content"
		};

		return axios
			.get(contentUrl)
			.then((result) => {
				const pageContent = result.data.pageContent;
				const commonContent = result.data.commonContent;

				if (pageContent && commonContent) {
					context.commit("updateContent", pageContent);
					context.commit("updateCommonContent", commonContent);
				} else {
					context.commit("updateContent", contentError);
				}
				return result.data;
			})
			.catch(() => {
				context.commit("updateContent", contentError);
			});
	}
};
